import request from '@/utils/request'
import api from '@/api'

const state = () => ({})
const getters = {}

const mutations = {}

const actions = {
  GetPaymentOrderForSettlement(context, params) {
    return request({
      url: api.GetPaymentOrderForSettlement,
      method: 'GET',
      params,
    })
  },
  SalesWorkFlowJsapiPayment(context, params) {
    return request({
      url: api.SalesWorkFlowJsapiPayment,
      method: 'POST',
      data: params,
    })
  },
  QueryTransactionStatus(context, params) {
    return request({
      url: api.QueryTransactionStatus,
      method: 'GET',
      params,
    })
  },
  // PackageGet(context, params) {
  //   return request({
  //     url: api.PackageGet,
  //     method: 'GET',
  //     params,
  //   })
  // },
  // PackageGetPackageDetailList(context, params) {
  //   return request({
  //     url: api.PackageGetPackageDetailList,
  //     method: 'GET',
  //     params,
  //   })
  // },
  // GetPackageByDetailId(context, params) {
  //   return request({
  //     url: api.GetPackageByDetailId,
  //     method: 'GET',
  //     params,
  //   })
  // },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
